import { render, staticRenderFns } from "./MonitoringAlertCamera.vue?vue&type=template&id=63b5e663&"
import script from "./MonitoringAlertCamera.vue?vue&type=script&lang=js&"
export * from "./MonitoringAlertCamera.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringAlertCamera.vue?vue&type=style&index=0&id=63b5e663&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports